import { PAYMENTS, FEATURE_ICONS } from "../../data/site";
import { DynIcon } from "../../lib/icons";
import { useLang } from "../../i18n/LangContext";
import { SectionHead } from "./Brand";

export const Payments = () => {
  const { pay: t } = useLang().t;
  return (
  <section id="payments" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
    <div className="grid gap-16 lg:grid-cols-5">
      <div className="lg:col-span-2">
        <SectionHead eyebrow={t.eyebrow} title={t.title} sub={t.sub} />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3" data-testid="payment-logos">
          {PAYMENTS.map((p) => (
            <div key={p.name} data-testid={`payment-${p.name.toLowerCase().replace(/\s/g, "-")}`} title={p.name}
              className="pay-tile group grid h-20 place-items-center rounded-xl border-2 border-[#D4AF37] bg-white px-4 transition-transform duration-300 hover:-translate-y-1">
              <img src={p.logo} alt={`${p.name} logo`} className="max-h-9 w-full object-contain" loading="lazy" />
            </div>
          ))}
        </div>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 lg:col-span-3">
        {t.features.map((f, i) => {
          const icon = f.icon || FEATURE_ICONS[i];
          return (
            <div key={i} className="glass-card p-7 transition-transform hover:-translate-y-1" data-testid={`feature-card-${i}`}>
              <div className="grid h-11 w-11 place-items-center rounded-full border border-[#D4AF37]/50 text-[#D4AF37] shadow-[0_0_18px_rgba(212,175,55,0.25)]">
                <DynIcon name={icon} size={18} />
              </div>
              <h3 className="mt-5 font-serif text-lg font-semibold text-white">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-400">{f.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
  );
};
